import { CategoryDataInterface } from 'shared/interface';
import NavigationItem from './navigationItem';

interface NavigationNavProps {
	className?: string;
	title?: string;
	menu?: any;
}

const NavigationPopularNav = ({ className, title, menu }: NavigationNavProps) => {
	return (
		<nav className={`navigation navigation_popular ${className}`}>
			{title && <strong className="navigation__title">{title}</strong>}
			<div className="navigation__content">
				{menu.map((item: CategoryDataInterface, index: any) => (
					<NavigationItem key={`${item.categoryId}`} item={item} iconType="sport|category" />
				))}
			</div>
		</nav>
	);
};

export default NavigationPopularNav;
